"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setContactStatusSchema = exports.CONTACT_NOTE_MAX = exports.CONTACT_FILTER_LABELS = exports.CONTACT_FILTERS = exports.NO_RESPONSE_WORKING_DAYS = exports.NO_RESPONSE_ATTEMPTS = exports.CONTACT_STEP_STAGES = exports.CONTACT_VIAS = exports.CONTACT_WITHDRAWAL_STATUSES = exports.CONTACT_MANUAL_STATUSES = exports.CONTACT_STATUS_LABELS = void 0;
exports.isContactStep = isContactStep;
exports.contactMovesFrom = contactMovesFrom;
exports.isOpenContactStatus = isOpenContactStatus;
exports.contactStatusAfterInvite = contactStatusAfterInvite;
exports.contactStatusAfterCall = contactStatusAfterCall;
exports.matchesContactFilter = matchesContactFilter;
const zod_1 = require("zod");
const state_machines_1 = require("./state-machines");
// R7 — the contact tracker (§L32, the §L25 Contact status machine, F24.06–F24.07; screen
// CON-01). Decisions: DECISIONS-LOG "Start R7", ADR 0042.
exports.CONTACT_STATUS_LABELS = {
    not_contacted: 'Not contacted',
    emailed: 'Emailed',
    no_answer: 'Called, no answer',
    reached: 'Reached',
    confirmed: 'Confirmed',
    not_interested: 'Not interested',
    no_response: 'No response',
    not_coming: 'Not coming',
};
/** What a recruiter sets by hand (§L25: `emailed` is the system's, set by a template invite). */
exports.CONTACT_MANUAL_STATUSES = ['no_answer', 'reached', 'confirmed', 'not_interested', 'no_response', 'not_coming'];
/** §L32: these two record a withdrawal with the candidate's §L20 reason. */
exports.CONTACT_WITHDRAWAL_STATUSES = ['not_interested', 'not_coming'];
/** §L32 `application.contact_status_changed` "via". */
exports.CONTACT_VIAS = ['email', 'call', 'manual', 'system'];
/**
 * §L32 "Next step": the steps after Contact. Arriving in one starts contact again at
 * `not_contacted` (§L25 "— → not_contacted … or moves on to a new step"), and the tracker
 * counts only what happened since.
 */
exports.CONTACT_STEP_STAGES = ['assessment', 'interview_1', 'interview_2', 'interview_3'];
function isContactStep(stage) {
    return exports.CONTACT_STEP_STAGES.includes(stage);
}
/** §L32 "suggested after 3 attempts, or after 2 working days with no reply to an email". */
exports.NO_RESPONSE_ATTEMPTS = 3;
exports.NO_RESPONSE_WORKING_DAYS = 2;
/** The statuses a person may move to from here, in the order the tracker offers them. */
function contactMovesFrom(from) {
    return exports.CONTACT_MANUAL_STATUSES.filter((to) => to !== from && (0, state_machines_1.canTransition)(state_machines_1.CONTACT_MACHINE, from, to, 'recruiter'));
}
function isOpenContactStatus(status) {
    return state_machines_1.OPEN_CONTACT_STATUSES.some((open) => open === status);
}
/** §L32 "sending a template invite sets `emailed` (from `not_contacted` or `no_answer`)". Null: no change. */
function contactStatusAfterInvite(from) {
    if (from === null)
        return null;
    return (0, state_machines_1.canTransition)(state_machines_1.CONTACT_MACHINE, from, 'emailed', 'system') ? 'emailed' : null;
}
/**
 * §L32 "Logging a call sets `reached` or `no_answer`". Only those two outcomes speak to
 * contact; "rescheduled" and "declined" leave the status for a person to set (a decline is a
 * withdrawal, which needs the candidate's reason). A second "no answer" changes nothing but
 * still counts as an attempt.
 */
function contactStatusAfterCall(from, outcome) {
    if (from === null || outcome === null)
        return null;
    if (outcome !== 'reached' && outcome !== 'no_answer')
        return null;
    if (outcome === from)
        return null;
    return (0, state_machines_1.canTransition)(state_machines_1.CONTACT_MACHINE, from, outcome, 'recruiter') ? outcome : null;
}
// --- CT-4's filters (O34) ----------------------------------------------------------------
exports.CONTACT_FILTERS = ['all', 'not_contacted', 'no_response', 'confirmed', 'not_coming'];
exports.CONTACT_FILTER_LABELS = {
    all: 'Everyone',
    not_contacted: 'Not contacted',
    no_response: 'No response after 2 days',
    confirmed: 'Confirmed',
    not_coming: 'Not coming',
};
/** O34: "who are we emailing, who are we calling, who isn't coming?" — one filter each. */
function matchesContactFilter(row, filter) {
    switch (filter) {
        case 'all':
            return true;
        case 'not_contacted':
            return row.contactStatus === 'not_contacted';
        case 'no_response':
            return row.contactStatus === 'no_response' || row.isNoResponseSuggested;
        case 'confirmed':
            return row.contactStatus === 'confirmed';
        case 'not_coming':
            return row.contactStatus === 'not_coming' || row.contactStatus === 'not_interested';
    }
}
// --- F24.06 -------------------------------------------------------------------------------
exports.CONTACT_NOTE_MAX = 1000;
exports.setContactStatusSchema = zod_1.z
    .object({
    to: zod_1.z.enum(exports.CONTACT_MANUAL_STATUSES),
    note: zod_1.z.string().trim().max(exports.CONTACT_NOTE_MAX, 'Keep it under 1,000 characters.').default(''),
    /** §L20, for Not interested and Not coming. */
    withdrawalReasonCode: zod_1.z.string().trim().min(1).nullable().default(null),
    version: zod_1.z.number().int().min(1),
})
    .refine((value) => !exports.CONTACT_WITHDRAWAL_STATUSES.includes(value.to) || value.withdrawalReasonCode !== null, {
    path: ['withdrawalReasonCode'],
    message: 'Pick the reason the candidate gave.',
});
//# sourceMappingURL=contact.js.map